/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';
import type { role } from '../models/role';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RolesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * List optional role templates
   * Returns role templates that can be used as a starting point when creating a new role (e.g. Recruiter, Compliance & Referral Manager).
   * @returns any List of optional role template descriptors
   * @throws ApiError
   */
  public getApiServiceauthorizationRolesTemplates(): CancelablePromise<{
    data?: Array<{
      key?: string;
      label?: string;
      description?: string;
    }>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/roles/templates',
    });
  }

  /**
   * Create a role from a template
   * Creates a single role using an optional template (see GET /roles/templates). Request body must include templateKey and role fields (e.g. companyUuid). Template defaults are merged; the new role receives that template's permission matrix.
   * @param requestBody
   * @returns any Role created from template
   * @throws ApiError
   */
  public postApiServiceauthorizationRolesFromTemplate(
    requestBody: {
      /**
       * Key of the template (e.g. recruiter, compliance_referral_manager).
       */
      templateKey: string;
      companyUuid: string;
      /**
       * Display name for the role.
       */
      label: string;
      enterpriseUuid?: string;
    },
  ): CancelablePromise<{
    /**
     * Created role (JSON:API resource)
     */
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/roles/from-template',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Missing or invalid templateKey, or invalid payload`,
      },
    });
  }

  /**
   * count roles
   * Count roles (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of role documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceauthorizationRolesCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/roles/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one role
   * Find one role by its unique identifier.
   * @param identifier role unique identifier
   * @returns any One role document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceauthorizationRoles(
    identifier: string,
  ): CancelablePromise<{
    data?: role;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/roles/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing role
   * Partially update one existing role
   * @param identifier role unique identifier
   * @param requestBody
   * @returns any updated role. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceauthorizationRoles(
    identifier: string,
    requestBody?: role,
  ): CancelablePromise<{
    data?: role;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceauthorization/roles/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one role
   * Delete one role
   * @param identifier role unique identifier
   * @returns any delete status roles. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceauthorizationRoles(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceauthorization/roles/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many roles
   * Find many roles (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many role documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceauthorizationRoles1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<role>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/roles',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple roles
   * Create one or multiple roles
   * @param requestBody
   * @returns any One or many role documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServiceauthorizationRoles(
    requestBody?: (role | Array<role>),
  ): CancelablePromise<{
    data?: (role | Array<role>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/roles',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing role
   * Partially update many existing role
   * @param requestBody
   * @returns any roles updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceauthorizationRoles1(
    requestBody?: Array<role>,
  ): CancelablePromise<{
    data?: Array<role>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceauthorization/roles',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many roles
   * Delete many roles using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status roles. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceauthorizationRoles1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceauthorization/roles',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
